import { useSelector } from 'react-redux';

import appSelectors from '@/redux/app/appSelectors';
import authSelectors from '@/redux/auth/authSelectors';

import useMatchMedia from '@/hooks/useMatchMedia';

import BtnLang from './btnLang';
import BtnNotification from './btnNotification';
import BtnMenu from './btnMenu';
import Menu from './menu';
import Breadcrumbs from './breadcrumbs';
import Logo from './logo';

import s from './header.module.css';

function Header() {
  const displayMenu = useSelector(appSelectors.displayMenu);
  const isAuth = useSelector(authSelectors.isAuthorized);

  const { isDesktop } = useMatchMedia();

  return (
    <header className={s.header} data-auth={isAuth}>
      <div className={s.container}>
        {(!isAuth || (isAuth && !isDesktop)) && <Logo />}
        {isAuth && isDesktop && <Breadcrumbs />}

        {!isAuth && <BtnLang />}
        {isAuth && <BtnNotification />}
        {isAuth && !isDesktop && <BtnMenu />}

        {isAuth && ((!isDesktop && displayMenu) || isDesktop) && <Menu />}
      </div>
    </header>
  );
}

export default Header;
